import { Component, Element, h, Host, Prop } from '@stencil/core';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-charts-card',
  styleUrl: 'pn-charts-card.scss',
})
export class PnChartsCard {
  @Element() hostElement: HTMLElement;
  //props
  @Prop() header: string = null;
  @Prop() highlight: string;
  @Prop() preamble: string;
  @Prop() label: string;
  @Prop() source: string;
  @Prop() sourceUrl: string;
  @Prop() ctaLinkText: string;
  @Prop() openInNewWindow: boolean = false;

  showCtaLinkText = () => {
    if (this.ctaLinkText) {
      return (
        <a class="link--animated" href={this.sourceUrl} rel={this.openInNewWindow ? 'noopener nofollower noreferrer' : null} target={this.openInNewWindow ? '_blank' : null}>
          {this.ctaLinkText} <pn-icon icon={arrow_right}> </pn-icon>
        </a>
      );
    }
    return null;
  };

  render() {
    return (
      <Host>
        <slot name="clickable-block-wrapper" />
        <div class="pn-charts-card__wrapper">
          {this.header &&
            (
              <div class="pn-charts-card__heading__wrapper pn-charts-card__heading__wrapper--vertical">
                <h2 class="pn-charts-card__heading">{this.header}</h2>
                <div class="pn-charts-card__heading__highlight">{this.highlight}</div>
              </div>
            )
          }
          <div class="pn-charts-card__content__wrapper">
            <slot name="chart"></slot>
            <div class="pn-charts-card__text__container">
              {this.header &&
                (
                  <div class="pn-charts-card__heading__wrapper pn-charts-card__heading__wrapper--horizontal">
                    <h2 class="pn-charts-card__heading pn-charts-card__heading">{this.header}</h2>
                    <div class="pn-charts-card__heading__highlight">{this.highlight}</div>
                  </div>
                )
              }
              <span class="pn-charts-card__preamble">{this.preamble}</span>
              <div class="pn-charts-card__text__wrapper">
                <div class="pn-charts-card__source">
                  <label>{this.label}</label>
                  {this.source ? <p class="pn-chart-card__text__heading">{this.source}</p> : null}
                  {this.showCtaLinkText()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
